import { WallType } from "./wallEnums";
import type { Wall, WallPath } from "./wallTypes";

export function getWallPath(wall: Wall): WallPath {
  if (wall.wallType === WallType.SOLID) {
    return wall.mass.path;
  }
  return wall.path;
}
